import { DropDownScholarResponse, DuplicateApplicationErrorType } from '@/Model/application/types';
import { ApplicationProgramDetails } from '@/Model/enrollment/types';
import { ApiErrorResponse } from '@/Model/error/api/types';
import { IActiveProgramPayload, ScholarDropdown } from '@/Model/model';
import { IApplicationData } from '@/Model/programModel';
import { Session } from '@/Model/sessions/types';
import APP_CONST from '@/constants/AppConst';
import MANAGE_FAMILY_CONST from '@/constants/ManageFamilyConst';
import router from '@/router';
import { getDocumentByApplicationGuid, getProgramSitesByAccId, getSiteByProgramId, updateAuthorizePickupData, updateScholarData } from '@/services/create-user/userService';
import { getAddedScholarData, getApplicationData, getDropDownScholars, getEnrolledApplications, getProgramsData, getScholarsByGuardian, getScholarsInfoByGuardian, scrubScholarIds } from '@/services/userService/users-api';
import store from '@/store';
import APP_UTILITIES from '@/utilities/commonFunctions';
import {
  Action,
  Module,
  Mutation,
  VuexModule,
  getModule
} from 'vuex-module-decorators';
import commonEntry from '../commonEntry';
import formsStore from '../forms/formsStore';
import MutationNames from './mutationNames';

const {
  DROPDOWN_SCHOLARS_REQUESTED,
  DROPDOWN_SCHOLARS_SUCCEEDED,
  DROPDOWN_SCHOLARS_FAILED,
  SCRUB_SCHOLAR_IDS_FAILED,
  SET_DUPLICATE_APPLICATION_ERROR_TYPE,
  SCRUB_SCHOLAR_IDS_SUCCEEDED,
  SCRUB_SCHOLAR_IDS_REQUESTED,
  RESET_SELECTED_CHILD,
  SET_PROGRAM_DETAILS_LOADING_BY_SCHOLAR,
  SET_SCHOLAR_DOCUMENTS_LOADING,
  SET_IS_LOADING_GET_ADDED_SCHOLAR_DATA
} = MutationNames;

@Module({
  namespaced: true,
  name: 'enrollmentManager',
  store,
  dynamic: true
})

export class ApplicationStoreModule extends VuexModule {
  APP_CONST = new APP_CONST;
  public siteList: Session[] | [] = [];
  public childrenDropdown = { label: '', id: 0, value: 'Select child', siteIds: [0], required: false, disable: false, search: false, placeholder: 'Search', dropdownList: [{ id: '', value: '', siteIds: [], isTemporary: '' }] as ScholarDropdown[] };
  public selectedChild: { id: number | string | undefined; value: string; siteIds: any } = { id: 0, value: '', siteIds: [0] };
  public applicationData: IApplicationData = JSON.parse(JSON.stringify(APP_CONST.APPLICATION_DATA));
  public allPrograms: any = [];
  public allSites: any = [];
  public sites: any = [];
  public activeProgramsArray: IActiveProgramPayload[] | [] = [];
  public waitListDeclinedApplications: any[] = [];
  public submittedScholarsLIst: any = [];
  public selectedScholarData: any = {};
  public editMode: boolean = false;
  public editScholarDetails: any = JSON.parse(JSON.stringify(MANAGE_FAMILY_CONST.EditScholarDetails));
  public editGuardianDetails: any = JSON.parse(JSON.stringify(MANAGE_FAMILY_CONST.EditGuardianDetails));
  public editEmergencyDetails: any = JSON.parse(JSON.stringify(MANAGE_FAMILY_CONST.EditEmergencyDetails));
  public editAuthorizedDetails: any = JSON.parse(JSON.stringify(MANAGE_FAMILY_CONST.EditAuthorizePickUp));
  public editSiteValues: any = JSON.parse(JSON.stringify(MANAGE_FAMILY_CONST.EditSiteDetails));
  public editSiteData: any = [];
  public scholarDocument: any = {};
  public applicationsGUIDS: any = [];
  public documentsArray: any = [];
  public requiredCount: number = 0;
  public currentScholar: any = {};
  public enrolledApplications: any = [];
  public changeSites: boolean = false;
  public isDocumentReqSumbit: boolean = true;
  public duplicateUserResponse: any = '';
  public programDetails: Array<ApplicationProgramDetails> | [] = [];
  public editModePrograms: boolean = false;
  public programLists: any = [];
  public deletedAuthorizePickups: any = [];
  public disableDocument: any = false;
  public outstandingItems: any = false;
  public duplicateMail: string = '';
  public duplicateApplicationErrorType: DuplicateApplicationErrorType | null = null;

  public isFetchingDropDownScholars = false;
  public didFailFetchingDropDownScholars = false;
  public dropDownScholarsFailError: ApiErrorResponse | null = null;
  public dropDownScholars: DropDownScholarResponse[] = [];

  public isScrubingScholarIds = false;
  public didFailScrubbingIds = false;
  public scrubScholarIdsFailError: ApiErrorResponse | null = null;
  public isSelectedScholarLoading: boolean = true;
  public isProgramDetailsByScholarLoading: boolean = false;
  public isScholarDocumentsLoading: boolean = false;
  public isLoadingGetAddedScholarData: boolean = false;

  get requiredCountNumber() {
    return this.requiredCount;
  }

  get isDisableDocument() {
    return this.disableDocument;
  }

  get isOutstandingItems() {
    return this.outstandingItems;
  }

  get requiredDocumnet() {
    return this.isDocumentReqSumbit;
  }

  get changeSite() {
    return this.changeSites;
  }

  get scholarDetails() {
    return this.editScholarDetails;
  }

  get guardianDetails() {
    return this.editGuardianDetails;
  }

  get authorizeDetails() {
    return this.editAuthorizedDetails;
  }

  get editSiteDetails() {
    return this.editSiteData;
  }

  get emergencyDetails() {
    return this.editEmergencyDetails;
  }

  get sitesList() {
    let selectedSites: any = localStorage.getItem('all_selected_sites')
      ? localStorage.getItem('all_selected_sites')
      : '';
    if (selectedSites && selectedSites != 'undefined') {
      selectedSites = JSON.parse(selectedSites);
      this.siteList && this.siteList.forEach((element: any) => {
        selectedSites.forEach((siteId: any) => {
          if (element.siteId == siteId) {
            element.selected = true;
          }
        });
      });
    }
    return this.siteList;
  }

  get childrenDropdownObj() {
    return this.childrenDropdown;
  }

  get selectedChildData() {
    return this.selectedChild;
  }

  get applicationDataInfo() {
    return this.applicationData.name
      ? this.applicationData
      : localStorage.getItem('applicationData')
        ? JSON.parse(localStorage.getItem('applicationData') || '')
        : '';
  }

  get allProgramsInApplication() {
    return this.allPrograms;
  }

  get allSitesInApplication() {
    return this.allSites;
  }

  get activeProgramWithScholarCount() {
    return this.activeProgramsArray;
  }

  get waitListDeniedApplications() {
    return this.waitListDeclinedApplications;
  }

  get submittedScholars() {
    const scholars = this.submittedScholarsLIst && this.submittedScholarsLIst.filter((elem: any, index: number) =>
      this.submittedScholarsLIst.findIndex((obj: any) => obj.guid === elem.guid) === index);
    return scholars;
  }

  get isFormEditModeActive() {
    return this.editMode;
  }

  get isFormProgramEditModeActive() {
    return this.editModePrograms;
  }

  get scholarDocuments() {
    let selectedScholarDocuments: any = localStorage.getItem('selectedScholarDocuments')
      ? localStorage.getItem('selectedScholarDocuments')
      : '';
    if (selectedScholarDocuments && selectedScholarDocuments != 'undefined') {
      selectedScholarDocuments = JSON.parse(selectedScholarDocuments);
    }
    return this.scholarDocument && this.scholarDocument.documentId
      ? this.scholarDocument
      : selectedScholarDocuments;
  }

  get applicationGuidsData() {
    return this.applicationsGUIDS;
  }

  get selectedScholar() {
    let selectedScholarDetails: any = localStorage.getItem('selectedScholarDetails')
      ? localStorage.getItem('selectedScholarDetails')
      : '';

    if (selectedScholarDetails && selectedScholarDetails != 'undefined') {
      selectedScholarDetails = JSON.parse(selectedScholarDetails);
    }
    return this.selectedScholarData && this.selectedScholarData.guid
      ? this.selectedScholarData
      : selectedScholarDetails;
  }

  get allEnrolledApplications() {
    return this.enrolledApplications;
  }

  get duplicateUsersResponse() {
    return this.duplicateUserResponse;
  }

  get programDetail(): Array<ApplicationProgramDetails> {
    let selectedProgramsDetails: any = localStorage.getItem('selectedProgramsDetails')
      ? localStorage.getItem('selectedProgramsDetails')
      : '';

    if (selectedProgramsDetails && selectedProgramsDetails != 'undefined') {
      selectedProgramsDetails = JSON.parse(selectedProgramsDetails);
    }
    return this.programDetails[0] && this.programDetails[0].programName
      ? this.programDetails
      : selectedProgramsDetails;
  }

  get programsList() {
    let selectedprogramLists: any = localStorage.getItem('programListData')
      ? localStorage.getItem('programListData')
      : '';

    if (selectedprogramLists && selectedprogramLists != 'undefined') {
      selectedprogramLists = JSON.parse(selectedprogramLists);
    }
    return this.programLists[0] && this.programLists[0].id
      ? this.programLists
      : selectedprogramLists;
  }

  get deletedAuthorizePickup() {
    return this.deletedAuthorizePickups;
  }

  get duplicateEmail() {
    return this.duplicateMail;
  }

  get allSelectedChildData(): ScholarDropdown | undefined {
    return this.childrenDropdownObj.dropdownList
      .filter(child => child.value === this.selectedChild.value)[0];
  }

  @Mutation
  mutateDuplicateEmail(email: string) {
    this.duplicateMail = email;
  }

  @Mutation
  mutateDeleteGaurdianFields(data: { data: any; index: number; activeLength: number }) {
    if (data.activeLength > 0) {
      if (this.editGuardianDetails[data.index].firstName.value == '' || this.editGuardianDetails[data.index].lastName.value == '' || this.editGuardianDetails[data.index].phone.value == '' || this.editGuardianDetails[data.index].email.value == '') {
        this.editGuardianDetails[data.index].firstName.value = APP_CONST.EMERGENCY_CONTACT_EMPTY_NAME;
        this.editGuardianDetails[data.index].lastName.value = APP_CONST.EMERGENCY_CONTACT_EMPTY_NAME;
        this.editGuardianDetails[data.index].email.value = APP_CONST.GUARDIAN_EMPTY_MAIL;
        this.editGuardianDetails[data.index].phone.value = APP_CONST.EMERGENCY_CONTACT_EMPTY_PHONE;
        this.editGuardianDetails[data.index].status.value = APP_CONST.GUARDIAN_DELETE_STATUS;
      }
      else {
        this.editGuardianDetails[data.index].status.value = APP_CONST.GUARDIAN_DELETE_STATUS;
      }
    }
    if (data.activeLength == 1) {
      this.editGuardianDetails = [...this.editGuardianDetails, ...JSON.parse(JSON.stringify(MANAGE_FAMILY_CONST.EditGuardianDetails))];
    }
  }

  @Mutation
  mutateDeleteEmergencyContactsFields(data: { data: any; index: number; activeLength: number }) {
    if (this.editEmergencyDetails.length) {
      for (let i = 0; i < this.editEmergencyDetails.length; i++) {
        if (this.editEmergencyDetails[i].callOrder.value > data.data.callOrder.value) {
          this.editEmergencyDetails[i].callOrder.value = this.editEmergencyDetails[i].callOrder.value - 1;

        }
        this.editEmergencyDetails[i].callOrder.listValues = this.editEmergencyDetails[i].callOrder.listValues.slice(0, -1);
      }
    }
    if (data.activeLength > 1) {
      if (this.editEmergencyDetails[data.index].firstName.value == '' || this.editEmergencyDetails[data.index].lastName.value == '' || this.editEmergencyDetails[data.index].phone.value == '') {
        this.editEmergencyDetails[data.index].firstName.value = APP_CONST.EMERGENCY_CONTACT_EMPTY_NAME;
        this.editEmergencyDetails[data.index].lastName.value = APP_CONST.EMERGENCY_CONTACT_EMPTY_NAME;
        this.editEmergencyDetails[data.index].phone.value = APP_CONST.EMERGENCY_CONTACT_EMPTY_PHONE;
        this.editEmergencyDetails[data.index].status.value = APP_CONST.EMERGENCY_CONTACT_DELETE_STATUS;
      }
      else {
        this.editEmergencyDetails[data.index].status.value = APP_CONST.EMERGENCY_CONTACT_DELETE_STATUS;
        //this.editEmergencyDetails[APP_CONST.ZERO].callOrder.value = 1;
      }
    }
    else if (data.activeLength == 1) {
      const tempEmenrgencyDetails = JSON.parse(JSON.stringify(MANAGE_FAMILY_CONST.EditEmergencyDetails));
      this.editEmergencyDetails.forEach((item: any, ind: number) => {
        if (data.index == ind) {
          Object.keys(item).forEach((itemKey: any) => {
            if (itemKey == 'firstName' || itemKey == 'lastName') {
              item[itemKey].value = APP_CONST.EMERGENCY_CONTACT_EMPTY_NAME;
            }
            else if (itemKey == 'phone') {
              item[itemKey].value = APP_CONST.EMERGENCY_CONTACT_EMPTY_PHONE;
            }
            else if (itemKey == 'status') {
              item[itemKey].value = APP_CONST.EMERGENCY_CONTACT_DELETE_STATUS;
            }
            else if (itemKey == 'calOrder') {
              item[itemKey].value = 1;
              item[itemKey].listValues = [];
            }
            else {
              if (item[itemKey] != 'Emergency Contact(s)') {
                item[itemKey].value = '';
              }
            }
          });
        }

      });
      tempEmenrgencyDetails[APP_CONST.ZERO].callOrder.value = APP_CONST.ONE;
      tempEmenrgencyDetails[APP_CONST.ZERO].callOrder.listValues.push(APP_CONST.ONE);
      this.editEmergencyDetails = [...this.editEmergencyDetails, ...JSON.parse(JSON.stringify(tempEmenrgencyDetails))];
    }
  }

  @Mutation
  mutateDisableSite(disableDocument: boolean) {
    this.disableDocument = disableDocument;
  }

  @Mutation
  mutateIsOutstandingItems(outstandingItems: boolean) {
    this.outstandingItems = outstandingItems;
  }

  @Mutation
  mutateChangeSite(change: boolean) {
    this.changeSites = change;
  }

  @Mutation
  mutateDuplicateErrorResponse(response: any) {
    this.duplicateUserResponse = response;
  }

  @Mutation
  async mutateScholarData(scholarData: any): Promise<any> {
    if (scholarData && scholarData.status && scholarData.status == APP_CONST.RESPONSE_400) {
      return scholarData;
    }
    this.selectedScholarData = scholarData;
    localStorage.setItem('selectedScholarDetails', JSON.stringify(scholarData));
  }

  @Mutation
  mutateScholarsList(scholarData: any) {
    this.submittedScholarsLIst = scholarData;
  }

  @Mutation
  mutateDocumentArray(documentsArray: any) {
    this.documentsArray = documentsArray;
  }

  @Mutation
  mutateDeletedForAuthorize(deletedAuthorizePickup: any) {
    if (deletedAuthorizePickup.length != 0) {
      this.deletedAuthorizePickups.push(deletedAuthorizePickup);
    }
    else {
      this.deletedAuthorizePickups = [];
    }
  }

  @Mutation
  mutateEditProgramFormMode(isEditMode: boolean) {
    this.editSiteData = [];
    this.editModePrograms = isEditMode;
    if (this.editModePrograms) {
      let selectedScholarDetails: any = localStorage.getItem('selectedScholarDetails')
        ? localStorage.getItem('selectedScholarDetails')
        : '';
      if (selectedScholarDetails && selectedScholarDetails != 'undefined') {
        selectedScholarDetails = JSON.parse(selectedScholarDetails);
        if (selectedScholarDetails.authorisedPickups && selectedScholarDetails.authorisedPickups.length) {
          this.editAuthorizedDetails = '';
          selectedScholarDetails.authorisedPickups.forEach(() => {
            this.editAuthorizedDetails = [...this.editAuthorizedDetails, ...JSON.parse(JSON.stringify(MANAGE_FAMILY_CONST.EditAuthorizePickUp))];
          });
        }
        else {
          this.editAuthorizedDetails = JSON.parse(JSON.stringify(MANAGE_FAMILY_CONST.EditAuthorizePickUp));
        }

        this.editAuthorizedDetails.forEach((item: any, index: number) => {
          Object.keys(item).forEach((itemKey: any) => {
            if (typeof (item[itemKey]) == 'object' && !Array.isArray(item[itemKey])) {
              if (selectedScholarDetails && selectedScholarDetails.authorisedPickups && selectedScholarDetails.authorisedPickups[index] && selectedScholarDetails.authorisedPickups[index][itemKey]) {
                if (itemKey === 'phoneType') {
                  item[itemKey].value = selectedScholarDetails.authorisedPickups[index][itemKey] == ''
                    ? ''
                    : selectedScholarDetails.authorisedPickups[index][itemKey];
                }
                else if (itemKey == 'pickUpEndDate' || itemKey == 'pickUpStartDate') {
                  item[itemKey].value = APP_UTILITIES.formatShortDateFullYear(selectedScholarDetails.authorisedPickups[index][itemKey]);
                  item[itemKey].value = item[itemKey].value !== ''
                    ? item[itemKey].value
                    : '';
                }
                else {
                  item[itemKey].value = selectedScholarDetails.authorisedPickups[index][itemKey];
                }
              }
            }
          });
        });
        let selectedProgramsDetails: any = localStorage.getItem('selectedProgramsDetails')
          ? localStorage.getItem('selectedProgramsDetails')
          : '';

        if (selectedProgramsDetails && selectedProgramsDetails != 'undefined') {
          selectedProgramsDetails = JSON.parse(selectedProgramsDetails);
          this.programDetails = selectedProgramsDetails;
        }
        this.programDetails[0] && this.programDetails[0].siteDetailList && this.programDetails.forEach((element: any) => {
          const programItemArray: any = [];
          element.siteDetailList && element.siteDetailList.forEach((sites: any) => {
            const item = JSON.parse(JSON.stringify(this.editSiteValues));
            Object.keys(item).forEach((itemKey: any) => {
              if (typeof (item[itemKey]) == 'object' && !Array.isArray(item[itemKey])) {
                if (sites.hasOwnProperty(itemKey)) {
                  item[itemKey].value = sites[itemKey] == ''
                    ? ''
                    : sites[itemKey];
                }
              }
            });
            programItemArray.push(item);
          });
          this.editSiteData.push(programItemArray);
        });
      }
      localStorage.setItem('initialSiteData', JSON.stringify(this.editSiteData));
      localStorage.setItem('initialAuthorizedDetails', JSON.stringify(this.editAuthorizedDetails));
    }
  }

  @Mutation
  mutateEditFormMode(isEditMode: boolean) {
    this.editMode = isEditMode;
    if (this.editMode) {
      let selectedScholarDetails: any = localStorage.getItem('selectedScholarDetails')
        ? localStorage.getItem('selectedScholarDetails')
        : '';
      if (selectedScholarDetails && selectedScholarDetails != 'undefined') {
        selectedScholarDetails = JSON.parse(selectedScholarDetails);
        this.editScholarDetails = JSON.parse(JSON.stringify(MANAGE_FAMILY_CONST.EditScholarDetails));
        const addressField = ['address1', 'address2', 'city', 'state', 'zip'];
        const medicalField = ['allergies', 'epiPen', 'asthmaInhaler', 'medication', 'insuranceProvider'];
        const scholarLearning = ['iep', 'llp', 'specialEducation'];
        this.editScholarDetails.forEach((item: any) => {
          Object.keys(item).forEach((itemKey: any) => {
            if (typeof (item[itemKey]) == 'object' && !Array.isArray(item[itemKey])) {
              if (selectedScholarDetails && selectedScholarDetails[itemKey] || (itemKey === 'ethnicity' && selectedScholarDetails['raceEthnicity'])) {
                if (itemKey === 'birthDate' || itemKey === 'enrollmentDate') {
                  item[itemKey].value = selectedScholarDetails[itemKey] !== ''
                    ? selectedScholarDetails[itemKey].replace(/\//g, ' - ')
                    : '';
                }
                else if (itemKey === 'phoneType') {
                  item[itemKey].value = selectedScholarDetails[itemKey] == ''
                    ? ''
                    : selectedScholarDetails[itemKey];
                }
                else if (itemKey === 'ethnicity') {
                  item[itemKey].value = selectedScholarDetails['raceEthnicity'] == ''
                    ? ''
                    : selectedScholarDetails['raceEthnicity'];
                }
                else {
                  item[itemKey].value = selectedScholarDetails[itemKey];
                }
              }
              else if (addressField.indexOf(itemKey) !== -1) {
                if (itemKey === 'state') {
                  item[itemKey].value = (selectedScholarDetails.address && selectedScholarDetails.address[itemKey] && selectedScholarDetails.address[itemKey] !== '')
                    ? selectedScholarDetails.address[itemKey]
                    : '';
                }
                else {
                  item[itemKey].value = selectedScholarDetails.address
                    ? selectedScholarDetails.address[itemKey]
                    : '';
                }
              }
              else if (medicalField.indexOf(itemKey) !== -1) {
                if (itemKey === 'epiPen' || itemKey === 'asthmaInhaler') {
                  item[itemKey].value = selectedScholarDetails.scholarMedical && selectedScholarDetails.scholarMedical[itemKey] != ''
                    ? selectedScholarDetails.scholarMedical[itemKey]
                    : '';
                }
                else {
                  item[itemKey].value = (selectedScholarDetails && selectedScholarDetails.scholarMedical && selectedScholarDetails.scholarMedical[itemKey])
                    ? selectedScholarDetails.scholarMedical[itemKey]
                    : '';
                }
              }
              else if (scholarLearning.indexOf(itemKey) !== -1) {
                item[itemKey].value = selectedScholarDetails && selectedScholarDetails.scholarLearning
                  ? selectedScholarDetails.scholarLearning[itemKey]
                  : '';
              }
            }
          });
        });

        if (selectedScholarDetails.guardianDetails && selectedScholarDetails.guardianDetails.length == 2) {
          this.editGuardianDetails = [...JSON.parse(JSON.stringify(MANAGE_FAMILY_CONST.EditGuardianDetails)), ...JSON.parse(JSON.stringify(MANAGE_FAMILY_CONST.EditGuardianDetails))];
        }
        else {
          this.editGuardianDetails = JSON.parse(JSON.stringify(MANAGE_FAMILY_CONST.EditGuardianDetails));
        }

        this.editGuardianDetails.forEach((item: any, index: number) => {
          if (selectedScholarDetails && selectedScholarDetails.guardianDetails && selectedScholarDetails.guardianDetails.length == 1) {
            if (this.editGuardianDetails.length == 2) {
              this.editGuardianDetails.pop();
            }
            this.editGuardianDetails[0].primaryGuardian.value = true;
          }
          Object.keys(item).forEach((itemKey: any) => {
            if (typeof (item[itemKey]) == 'object' && !Array.isArray(item[itemKey])) {
              if (selectedScholarDetails && selectedScholarDetails.guardianDetails && selectedScholarDetails.guardianDetails[index] && selectedScholarDetails.guardianDetails[index][itemKey]) {
                if (itemKey === 'birthDate' || itemKey === 'enrollmentDate') {
                  item[itemKey].value = selectedScholarDetails.guardianDetails[index][itemKey] !== ''
                    ? selectedScholarDetails.guardianDetails[index][itemKey].replace(/\//g, ' - ')
                    : '';
                }
                else if (itemKey === 'phoneType' || itemKey === 'raceEthnicity') {
                  item[itemKey].value = selectedScholarDetails.guardianDetails[index][itemKey] == ''
                    ? ''
                    : selectedScholarDetails.guardianDetails[index][itemKey];
                }
                else {
                  item[itemKey].value = selectedScholarDetails.guardianDetails[index][itemKey];
                }
              }
              else if (selectedScholarDetails.guardianDetails && addressField.indexOf(itemKey) !== -1 && selectedScholarDetails.guardianDetails[index] && selectedScholarDetails.guardianDetails[index].address) {
                if (itemKey === 'state') {
                  item[itemKey].value = selectedScholarDetails.guardianDetails[index].address[itemKey] == ''
                    ? ''
                    : selectedScholarDetails.guardianDetails[index].address[itemKey];
                }
                else {
                  item[itemKey].value = selectedScholarDetails.guardianDetails[index].address[itemKey];
                }
              }
            }
          });
        });

        const tempEmenrgencyDetails = JSON.parse(JSON.stringify(MANAGE_FAMILY_CONST.EditEmergencyDetails));
        if (selectedScholarDetails.emergencyContacts && selectedScholarDetails.emergencyContacts.length) {
          this.editEmergencyDetails = '';
          selectedScholarDetails.emergencyContacts.forEach((emergency: any) => {
            tempEmenrgencyDetails[APP_CONST.ZERO].callOrder.value = emergency.callOrder;
            this.editEmergencyDetails = [...this.editEmergencyDetails, ...JSON.parse(JSON.stringify(tempEmenrgencyDetails))];
          });
          for (let i = 0; i < this.editEmergencyDetails.length; i++) {
            for (let j = 0; j < this.editEmergencyDetails.length; j++) {
              this.editEmergencyDetails[i].callOrder.listValues.push(j + 1);
            }
          }
        }
        else {
          tempEmenrgencyDetails[APP_CONST.ZERO].callOrder.value = APP_CONST.ONE;
          this.editEmergencyDetails = JSON.parse(JSON.stringify(tempEmenrgencyDetails));
          for (let i = 0; i < this.editEmergencyDetails.length; i++) {
            for (let j = 0; j < this.editEmergencyDetails.length; j++) {
              if (!this.editEmergencyDetails[i].callOrder.listValues.includes(j + 1)) {
                this.editEmergencyDetails[i].callOrder.listValues.push(j + 1);
              }
            }
          }
        }

        this.editEmergencyDetails.forEach((item: any, index: number) => {
          Object.keys(item).forEach((itemKey: any) => {
            if (typeof (item[itemKey]) == 'object' && !Array.isArray(item[itemKey])) {
              if (selectedScholarDetails && selectedScholarDetails.emergencyContacts && selectedScholarDetails.emergencyContacts[index] && selectedScholarDetails.emergencyContacts[index][itemKey]) {
                if (itemKey === 'phoneType' || itemKey === 'raceEthnicity') {
                  item[itemKey].value = selectedScholarDetails.emergencyContacts[index][itemKey] == ''
                    ? ''
                    : selectedScholarDetails.emergencyContacts[index][itemKey];
                }
                else {
                  item[itemKey].value = selectedScholarDetails.emergencyContacts[index][itemKey];
                }
              }
            }
          });
        });
      }

      localStorage.setItem('initialEmergencyDetails', JSON.stringify(this.editEmergencyDetails));
      localStorage.setItem('initialGuardianDetails', JSON.stringify(this.editGuardianDetails));
      localStorage.setItem('initialScholarDetails', JSON.stringify(this.editScholarDetails));
    }
  }
  @Mutation
  [SET_PROGRAM_DETAILS_LOADING_BY_SCHOLAR](isProgramDetailsByScholarLoading: boolean) {
    this.isProgramDetailsByScholarLoading = isProgramDetailsByScholarLoading;
  }

  @Mutation
  [SET_SCHOLAR_DOCUMENTS_LOADING](isScholarDocumentsLoading: boolean) {
    this.isScholarDocumentsLoading = isScholarDocumentsLoading;
  }

  @Mutation
  [SET_IS_LOADING_GET_ADDED_SCHOLAR_DATA](isLoadingGetAddedScholarData: boolean) {
    this.isLoadingGetAddedScholarData = isLoadingGetAddedScholarData;
  }

  @Mutation
  mutateApplicationData(applicationData: IApplicationData) {
    this.applicationData = applicationData;
  }

  @Mutation
  mutateChildrenDropdown(dropDown: any) {
    this.childrenDropdown = dropDown;
  }

  @Mutation
  mutateSiteList(siteList: any) {
    this.siteList = siteList;
  }

  @Mutation
  individualSiteSelection(site: { siteId: string; selected: boolean }) {
    const scholarIndex = this.siteList.findIndex((el: any) => el.siteId == site.siteId);
    this.siteList[scholarIndex].selected = this.siteList[scholarIndex] && this.siteList[scholarIndex].selected && site && site.selected;
    this.siteList = [...this.siteList];
  }

  @Mutation
  mutateCheckedSites(sites: any) {
    sites && sites.forEach((siteId: number) => {
      const scholarIndex = this.siteList.findIndex((el: any) => el.siteId == siteId);
      if (this.siteList[scholarIndex]) {
        this.siteList[scholarIndex].selected = this.siteList[scholarIndex] && this.siteList[scholarIndex].selected && true;
      }
      this.siteList = [...this.siteList];
    });
  }

  @Mutation
  mutateSelectedChild(child: { id: number | string; value: string; siteIds: any }) {
    this.selectedChild = child;
  }

  @Mutation
  mutatePrograms(programs: any) {
    this.allPrograms = programs;
  }

  @Mutation
  mutateSites(sites: any) {
    this.allSites = sites;
    this.sites = sites;
  }

  @Mutation
  mutateProgramsSitesArry(programs: any) {
    programs && programs.forEach((program: any) => {
      program.sites = program.sites.sort(function (a: any, b: any) {
        if (a.siteName < b.siteName) {
          return -1;
        }
        if (a.siteName > b.siteName) {
          return 1;
        }
        return 0;
      });
    });
    this.activeProgramsArray = programs;
  }

  @Mutation
  mutateNewEmergency() {
    const tempEmergencyDetails = JSON.parse(JSON.stringify(MANAGE_FAMILY_CONST.EditEmergencyDetails));
    const editEmergencyDetailsExculdingDelete: any = [];
    this.editEmergencyDetails.forEach((emergency: any) => {
      if (emergency.status && emergency.status.value == '') {
        editEmergencyDetailsExculdingDelete.push(emergency);
      }
    });

    tempEmergencyDetails[APP_CONST.ZERO].callOrder.value = editEmergencyDetailsExculdingDelete.length + 1;
    this.editEmergencyDetails = [...this.editEmergencyDetails, ...JSON.parse(JSON.stringify(tempEmergencyDetails))];

    for (let i = 0; i < this.editEmergencyDetails.length; i++) {
      if (this.editEmergencyDetails[i].status && this.editEmergencyDetails[i].status.value == '3') {
        continue;
      }
      for (let j = 0; j < editEmergencyDetailsExculdingDelete.length + 1; j++) {
        if (!this.editEmergencyDetails[i].callOrder.listValues.includes(j + 1)) {
          this.editEmergencyDetails[i].callOrder.listValues.push(j + 1);
        }
      }
    }
  }

  @Mutation
  mutateNewGuardian() {
    this.editGuardianDetails = [...this.editGuardianDetails, ...JSON.parse(JSON.stringify(MANAGE_FAMILY_CONST.EditGuardianDetails))];
  }

  @Mutation
  mutateNewAuthorize(index?: number) {
    if (index != undefined) {
      if (this.editAuthorizedDetails.length == 1) {
        this.editAuthorizedDetails.splice(index, 1);
        this.editAuthorizedDetails = [...this.editAuthorizedDetails, ...JSON.parse(JSON.stringify(MANAGE_FAMILY_CONST.EditAuthorizePickUp))];
        return;
      }
      this.editAuthorizedDetails.splice(index, 1);
    }
    else {
      this.editAuthorizedDetails = [...this.editAuthorizedDetails, ...JSON.parse(JSON.stringify(MANAGE_FAMILY_CONST.EditAuthorizePickUp))];
    }
  }

  @Mutation
  MutateWailistDeniedApplications(applications: any) {
    applications = applications.sort(function (a: any, b: any) {
      if (a.siteDetails.siteName < b.siteDetails.siteName) {
        return -1;
      }
      if (a.siteDetails.siteName > b.siteDetails.siteName) {
        return 1;
      }
      return 0;
    });
    const pendingApplications = applications.filter((el: any) => {
      return el.enrollmentStatus == APP_CONST.SCHOLAR_ENROLL_STATUS_PENDING;
    });
    const waitListedApplications = applications.filter((el: any) => {
      return el.enrollmentStatus == APP_CONST.SCHOLAR_ENROLL_STATUS_WAITLIST;
    });
    const declinedApplications = applications.filter((el: any) => {
      return el.enrollmentStatus == APP_CONST.SCHOLAR_ENROLL_STATUS_DECLINED;
    });
    pendingApplications.push(...waitListedApplications);
    pendingApplications.push(...declinedApplications);
    this.waitListDeclinedApplications = pendingApplications;
  }


  @Mutation
  mutateScholarDocument(scholarDocument: any) {
    if (scholarDocument.length != undefined) {
      scholarDocument = scholarDocument && scholarDocument.sort(function (a: any, b: any) {
        if (a.document && b.document) {
          if (a.document.name < b.document.name) {
            return -1;
          }
          if (a.document.name > b.document.name) {
            return 1;
          }
        }
        return 0;
      });
      scholarDocument = scholarDocument && scholarDocument.filter((el: any) => {
        return el.isCheck == true;
      });
      let isRequiredDocument = scholarDocument.filter((el: any) => {
        return el.isRequired == true;
      });
      const isNotRequiredDocument = scholarDocument.filter((el: any) => {
        return el.isRequired == false;
      });
      isRequiredDocument.push(...isNotRequiredDocument);
      isRequiredDocument = isRequiredDocument.filter((elem: any, index: number) =>
        isRequiredDocument.findIndex((obj: any) => obj.documentId === elem.documentId) === index);
      const isRequiredDocumentList = isRequiredDocument.filter((el: any) => {
        return el.isRequired == true;
      });
      for (let i = 0; i < isRequiredDocument.length; i++) {
        if (isRequiredDocument[i].isRequired && !isRequiredDocument[i].isFileAdded) {
          this.isDocumentReqSumbit = true;
          break;
        }
        else {
          this.isDocumentReqSumbit = false;
        }
      }
      this.requiredCount = isRequiredDocumentList.length;
      this.scholarDocument = isRequiredDocument;
    }
    else {
      this.scholarDocument = scholarDocument;
    }
    localStorage.setItem('selectedScholarDocuments', JSON.stringify(this.scholarDocument));
  }

  @Mutation
  mutateDocumentReqSumbit(isDocumentReqSumbit: boolean) {
    this.isDocumentReqSumbit = isDocumentReqSumbit;
  }

  @Mutation
  mutateEnrolledApplications(applications: any) {
    this.enrolledApplications = applications.data;
  }

  @Mutation
  updatePartIndex(application: { submissions: any; index: number }) {
    const applicationSubmissions = application.submissions;
    const currentPartIndex = application.index;
    APP_UTILITIES.setCookie('outStandingItemIndex', JSON.stringify(currentPartIndex), 1);
    APP_UTILITIES.setCookie('elasticEnrollmentId', JSON.stringify(applicationSubmissions[currentPartIndex] && applicationSubmissions[currentPartIndex].elasticSubmissionId), 1);
    APP_UTILITIES.setCookie('scholarId', JSON.stringify(applicationSubmissions[currentPartIndex] && applicationSubmissions[currentPartIndex].scholarId), 1);

    localStorage.setItem('scholar_selected', JSON.stringify(false));
    localStorage.setItem('all_selected_sites', JSON.stringify(applicationSubmissions[currentPartIndex] && applicationSubmissions[currentPartIndex].siteIds));

    formsStore.saveFormsData({ data: applicationSubmissions[currentPartIndex] && applicationSubmissions[currentPartIndex].elasticSubmissionId });

    /* istanbul ignore else */
    if (applicationSubmissions[currentPartIndex]) {
      const applicationData: any = { applicationGuid: '', elasticApplicationId: '', name: '', programId: 0, siteIds: '', scholar_firstname: '', accountId: '', scholarId: '', elasticSubmissionId: '' };
      applicationData.applicationGuid = applicationSubmissions[currentPartIndex].applicationGuid;
      applicationData.elasticApplicationId = applicationSubmissions[currentPartIndex].elasticApplicationId;
      applicationData.elasticSubmissionId = applicationSubmissions[currentPartIndex].elasticSubmissionId;
      applicationData.name = applicationSubmissions[currentPartIndex].name;
      applicationData.programId = applicationSubmissions[currentPartIndex].programId;
      applicationData.scholar_firstname = applicationSubmissions[currentPartIndex].scholarFirstName;
      applicationData.accountId = applicationSubmissions[currentPartIndex].accountId;
      applicationData.scholarId = applicationSubmissions[currentPartIndex].scholarId;
      applicationData.siteIds = applicationSubmissions[currentPartIndex].siteIds;
      this.applicationData = applicationData;
      localStorage.setItem('applicationData', JSON.stringify(applicationData));
    }
  }

  @Mutation
  mutateProgramList(programList: any) {
    this.programLists = [];
    this.programLists = programList;
    localStorage.setItem('programListData', JSON.stringify(programList));
  }

  @Mutation
  mutateGetProgramDetails(programs: any) {
    programs.forEach((element: any) => {
      element.siteDetailList && element.siteDetailList.forEach((element1: any) => {
        if (element1.enrolStatus == 10) {
          element.zeroEnrolment = true;
        }
        else {
          element.zeroEnrolment = false;
          return;
        }
      });
      if (element.siteDetailList) {
        element.siteDetailList = element.siteDetailList && element.siteDetailList.filter((el: any) => {
          return el.enrolStatus == 10;
        });
      }
    });
    programs = programs && programs.filter((el: any) => {
      return el.siteDetailList.length;
    });
    this.programDetails = programs;
    localStorage.setItem('selectedProgramsDetails', JSON.stringify(programs));
  }

  @Mutation
  [SCRUB_SCHOLAR_IDS_REQUESTED]() {
    this.isScrubingScholarIds = true;
    this.didFailScrubbingIds = false;
    this.scrubScholarIdsFailError = null;
  }

  @Mutation
  [SCRUB_SCHOLAR_IDS_SUCCEEDED]() {
    this.isScrubingScholarIds = false;
    this.didFailScrubbingIds = false;
    this.scrubScholarIdsFailError = null;
  }

  @Mutation
  [SCRUB_SCHOLAR_IDS_FAILED](error: ApiErrorResponse) {
    this.isScrubingScholarIds = false;
    this.didFailScrubbingIds = true;
    this.scrubScholarIdsFailError = error;
  }



  @Mutation
  [DROPDOWN_SCHOLARS_REQUESTED]() {
    this.isFetchingDropDownScholars = true;
    this.didFailFetchingDropDownScholars = false;
    this.dropDownScholarsFailError = null;
  }

  @Mutation
  [DROPDOWN_SCHOLARS_SUCCEEDED](payload: { ddsResponse: DropDownScholarResponse[]; ddsMapped: ScholarDropdown[] }) {
    const { ddsResponse, ddsMapped } = payload;
    this.childrenDropdown.dropdownList = [...ddsMapped, APP_CONST.ADD_NEW_CHILD];
    this.dropDownScholars = ddsResponse;
    this.isFetchingDropDownScholars = false;
    this.didFailFetchingDropDownScholars = false;
    this.dropDownScholarsFailError = null;
  }

  @Mutation
  [DROPDOWN_SCHOLARS_FAILED](error: ApiErrorResponse) {
    this.childrenDropdown.dropdownList.length = 0;
    this.dropDownScholars.length = 0;
    this.isFetchingDropDownScholars = false;
    this.didFailFetchingDropDownScholars = true;
    this.dropDownScholarsFailError = error;
  }

  @Mutation
  [SET_DUPLICATE_APPLICATION_ERROR_TYPE](duplicateApplicationErrorType: DuplicateApplicationErrorType) {
    this.duplicateApplicationErrorType = duplicateApplicationErrorType;
  }

  @Action
  async getScholarData(guid: string): Promise<any> {
    if (guid) {
      APP_UTILITIES.setCookie('currentScholarGuid', JSON.stringify(guid), 1);
      this.SET_IS_LOADING_GET_ADDED_SCHOLAR_DATA(true);
      const result = await getAddedScholarData({ id: guid });
      this.SET_IS_LOADING_GET_ADDED_SCHOLAR_DATA(false);
      if (result.status == APP_CONST.RESPONSE_200) {
        if (router.currentRoute.path != APP_CONST.APP_ROUTES.APPLICATION_UPLOAD_DOCUMENTS.path) {
          this.getProgramDetailsByScholarGuid(guid);
        }
        this.mutateScholarData(result.data[0]);
        localStorage.setItem('selectedGuid', JSON.stringify(result.data[0].guid));
        if (APP_UTILITIES.getCookie('outStandingItems')) {
          const currentIndex: any = APP_UTILITIES.getCookie('outStandingItemIndex');
          const outStandingItems: any = APP_UTILITIES.getCookie('outStandingItems');
          const currentOutstandingItem: any = JSON.parse(outStandingItems)[currentIndex];
          const applicationGUIDS: any = [];
          applicationGUIDS.push(currentOutstandingItem.applicationGuid);
          this.getScholarDocumentByApplicationGUID(applicationGUIDS);
        }
        else {
          this.getScholarDocumentByApplicationGUID(result.data[0].applicationGuids);
        }
      }
      return result;
    }
  }


  @Action
  async getScholarDocumentByApplicationGUID(applicationGuids: any): Promise<any> {
    this.SET_SCHOLAR_DOCUMENTS_LOADING(true);
    let response: any = {};
    for (let i = 0; i < applicationGuids.length; i++) {
      if (applicationGuids[i] == '00000000-0000-0000-0000-000000000000') {
        continue;
      }
      response = await getDocumentByApplicationGuid(applicationGuids[i]);
      if (response.status === APP_CONST.RESPONSE_200) {
        this.selectedScholarData.documents && this.selectedScholarData.documents.forEach((element: any) => {
          response.data && response.data.forEach((element1: any) => {
            if (element.docId == element1.documentId) {
              element1.fileName = element.fileName;
              element1.url = element.url;
              element1.isFileAdded = true;
              element1.scholarDocumentId = element.guid;
              element1.submissionOn = element.submissionOn;
            }
          });
        });
        this.documentsArray.push(...response.data);
      }
    }
    const document: any = [];
    this.selectedScholarData.documents && this.selectedScholarData.documents.forEach((element: any) => {
      element.isFileAdded = true;
      element.isCheck = true;
      element.isRequired = false;
      element.documentId = element.docId || element.guid;
      element.scholarDocumentId = element.guid;
      document.push(element);
    });
    this.documentsArray.push(...document);
    this.mutateScholarDocument(this.documentsArray);
    this.SET_SCHOLAR_DOCUMENTS_LOADING(false);
    return response.data;
  }

  @Action
  async getProgramDetailsByScholarGuid(guid: string): Promise<any> {
    this.SET_PROGRAM_DETAILS_LOADING_BY_SCHOLAR(true);
    const { accountId } = await APP_UTILITIES.coreidsAsync();
    const payload: any = {
      ScholarId: guid,
      accountId: accountId,
      programId: 0,
      siteId: 0
    };
    const response = await getProgramsData(payload);
    this.mutateGetProgramDetails(response.data.programDetails);
    this.mutateProgramList(response.data.programList);
    this.SET_PROGRAM_DETAILS_LOADING_BY_SCHOLAR(false);
    return response;

  }

  @Action
  async getSitesByProgramId(programId: number): Promise<any> {
    await getSiteByProgramId(programId).then((res) => {
      if (res.status === APP_CONST.RESPONSE_200) {
        const siteIds: any = this.applicationData.siteIds;
        const data: any = [];
        res.data.forEach((element: any) => {
          siteIds && siteIds.forEach((siteId: number) => {
            if (element.sessionId == siteId) {
              data.push(element);
            }
          });
        });
        this.mutateSiteList(data);
      }
      return res.data;
    });
  }

  @Action
  async updateApplicationData(id: any) {
    const response = await getApplicationData(id);
    /* istanbul ignore else */
    if (response.status == APP_CONST.RESPONSE_200) {
      if (response.data) {
        if (response.data.status != APP_CONST.APPLICATION_PUBLISHED_STATUS) {
          router.push('/applicationemptystate');
        }
        else {
          const applicationData = { applicationGuid: '', id: '', elasticApplicationId: '', name: '', programId: 0, programName: '', siteIds: 'str', accountId: '' };
          applicationData.applicationGuid = response.data.applicationGuid;
          applicationData.id = response.data.id;
          applicationData.elasticApplicationId = response.data.elasticApplicationId;
          applicationData.name = response.data.name;
          applicationData.programId = response.data.programId;
          applicationData.programName = response.data.programName;
          applicationData.siteIds = response.data.siteIds;
          applicationData.accountId = response.data.accountId;

          localStorage.setItem('applicationData', JSON.stringify(applicationData));
          this.mutateApplicationData(response.data);
          setTimeout(() => {
            if (commonEntry.accountDesignDetails && response.data.accountId !== commonEntry.accountDesignDetails.accountId) {
              router.push('/pagenotfound');
            }
          }, 1000);
        }
      }
    }
    else {
      router.push('/pagenotfound');
    }
    return response;
  }

  @Action
  async getProgramSitesByAccId(accountId: number): Promise<any> {
    await getProgramSitesByAccId(accountId).then((res) => {
      if (res.status === APP_CONST.RESPONSE_200) {
        const data = res.data;
        const programsData: any = [];
        const sitesData: any = [];
        data.forEach((element: any) => {
          if (element.programId && !element.siteId) {
            element.isCompleted = true;
            programsData.push(element);
          }
          else if (element.programId && element.siteId && element.siteStatus == APP_CONST.ONE) {
            element.scholarCount = 0;
            element.siteSelectedDays = element.siteSelectedDays.replace(/,/g, ', ');
            sitesData.push(element);
          }
        });
        this.mutatePrograms(programsData);
        this.mutateSites(sitesData);
      }
      return res.data;
    });
  }

  @Action
  async getScholarsByGuardian(): Promise<any> {
    await getScholarsByGuardian().then((res) => {
      if (res.status === APP_CONST.RESPONSE_200) {
        const data = res.data;
        // this.mutateScholarsList(res.data)
        const filteredScholars = data.filter((program: { guid: number; firstName: string; lastName: string; status: number; siteIds: any }) => {
          return program.status === APP_CONST.ONE;
        });
        const mappedScholars = filteredScholars.map((program: { guid: number; firstName: string; lastName: string; siteIds: any }) => {
          return { id: program.guid, value: program.firstName + ' ' + program.lastName, siteIds: program.siteIds };
        }) || [];
        mappedScholars.sort((a: any, b: any) => (a.value > b.value)
          ? 1
          : ((b.value > a.value)
            ? -1
            : 0));
        this.mutateChildrenDropdown({ ...this.childrenDropdown, dropdownList: [...mappedScholars, { id: '-1', value: 'I\'ll be adding a new child', siteIds: [-1] }] });
      }
      else if (res.status === APP_CONST.RESPONSE_204) {
        this.mutateChildrenDropdown({ ...this.childrenDropdown, dropdownList: [{ id: '-1', value: 'I\'ll be adding a new child', siteIds: [-1] }] });
      }
      return res.data;
    });
  }

  @Action
  async getDropDownScholars(userId: number): Promise<any> {
    try {
      this.DROPDOWN_SCHOLARS_REQUESTED();
      const response = (await getDropDownScholars(userId)).data;
      const mappedScholars = response.scholars.map((scholar: { guid: string; scholarFirstName: string; scholarLastName: string; scholarDateOfBirth: string; siteIds: number[]; isTemporary: boolean }) => {
        const isTemporaryValue = scholar.isTemporary
          ? `${scholar.scholarFirstName} ${scholar.scholarLastName} (<em style="color:${ APP_CONST.STYLE.COLOR.NEUTRAL_600 }">new</em>)`
          : '';
        return { id: scholar.guid, value: `${scholar.scholarFirstName} ${scholar.scholarLastName}`, isTemporary: isTemporaryValue, siteIds: scholar.siteIds, firstName: scholar.scholarFirstName, lastName: scholar.scholarLastName, DOB: scholar.scholarDateOfBirth };
      }) || [];
      mappedScholars.sort((a: any, b: any) => (a.value > b.value)
        ? 1
        : ((b.value > a.value)
          ? -1
          : 0));
      const payload = { ddsResponse: response, ddsMapped: mappedScholars };
      this.DROPDOWN_SCHOLARS_SUCCEEDED(payload);
    }
    catch (error) {
      const apiErrorResponse: ApiErrorResponse = APP_UTILITIES.errorToApiErrorResponse(error);
      this.DROPDOWN_SCHOLARS_FAILED(apiErrorResponse);
    }
  }

  @Action
  async scrubScholarIds(activeCartId: number): Promise<any> {
    try {
      this.SCRUB_SCHOLAR_IDS_REQUESTED();
      await scrubScholarIds(activeCartId);

      this.SCRUB_SCHOLAR_IDS_SUCCEEDED();
    }
    catch (error) {
      const apiErrorResponse: ApiErrorResponse = APP_UTILITIES.errorToApiErrorResponse(error);
      this.SCRUB_SCHOLAR_IDS_FAILED(apiErrorResponse);
    }
  }

  @Action({ commit: 'mutateScholarData' })
  async updateScholarData(scholarData: any) {
    const result = await updateScholarData(scholarData);
    if (result.status == APP_CONST.RESPONSE_400) {
      return result;
    }
    else {
      if (APP_UTILITIES.getCookie('currentScholarGuid')) {
        const guid: any = APP_UTILITIES.getCookie('currentScholarGuid');
        const result = await getAddedScholarData({ id: JSON.parse(guid) });
        if (result.status == APP_CONST.RESPONSE_200) {
          scholarData = result.data[0];
        }
      }
      const response = await getScholarsInfoByGuardian();
      this.mutateScholarsList(response.data);
    }
    return scholarData;
  }

  @Action
  async updateAuthorizeData(authorizeData: any) {
    let guid: any = '';
    if (APP_UTILITIES.getCookie('currentScholarGuid')) {
      guid = APP_UTILITIES.getCookie('currentScholarGuid');
    }
    const result = await updateAuthorizePickupData(JSON.parse(guid), authorizeData);
    if (result.status == APP_CONST.RESPONSE_400) {
      return result;
    }
    else {
      if (APP_UTILITIES.getCookie('currentScholarGuid')) {
        const result = await getAddedScholarData({ id: JSON.parse(guid) });
        if (result.status == APP_CONST.RESPONSE_200) {
          this.mutateScholarData(result.data[0]);
          localStorage.setItem('selectedGuid', JSON.stringify(result.data[0].guid));
          this.getProgramDetailsByScholarGuid(JSON.parse(guid));
        }
      }
    }
    return result;
  }

  @Action
  async getScholarsInfoByGuardian() {
    const response = await getScholarsInfoByGuardian();
    let data = response.data;
    this.mutateScholarsList(response.data);
    /* istanbul ignore else */
    if (response.status == APP_CONST.RESPONSE_200) {
      data = data && data.filter((el: any) => {
        return el.submissionGuid != '00000000-0000-0000-0000-000000000000';
      });
      data && data.forEach((scholar: any) => {
        if (scholar.scholarSiteMapping && scholar.scholarSiteMapping.length) {
          scholar.scholarSiteMapping.forEach((site: any) => {
            if (site.enrollmentStatus == APP_CONST.SCHOLAR_ENROLL_STATUS_ENROLLED) {
              const siteIndex = this.allSites.findIndex((el: any) => el.siteId == site.siteId);
              if (site.siteId) {
                this.allSites[siteIndex] && this.allSites[siteIndex].scholarCount++;
              }
            }
          });
        }
      });
      const activePrograms: any = [];
      this.allPrograms.forEach((program: any, programIndex: number) => {
        program.sites = [];
        let siteIndex = 0;
        this.allSites.forEach((site: any) => {
          if (program.programId == site.programId && site.scholarCount) {
            activePrograms[programIndex] = program;
            activePrograms[programIndex].sites[siteIndex] = site;
            siteIndex++;
          }
        });
      });
      this.mutateProgramsSitesArry(activePrograms);

      const mappingsArray: any = [];
      data && data.forEach((scholar: any) => {
        scholar.scholarSiteMapping && scholar.scholarSiteMapping.forEach((site: any) => {
          if (site.enrollmentStatus == APP_CONST.SCHOLAR_ENROLL_STATUS_WAITLIST || site.enrollmentStatus == APP_CONST.SCHOLAR_ENROLL_STATUS_DECLINED || site.enrollmentStatus == APP_CONST.SCHOLAR_ENROLL_STATUS_PENDING) {
            site.scholarName = scholar.firstName;
            mappingsArray.push(site);
          }
        });
      });
      mappingsArray.forEach((site: any) => {
        const mappedSiteIndex = this.sites.findIndex((el: any) => el.siteId == site.siteId);
        if (mappedSiteIndex !== -1) {
          site.siteDetails = this.sites[mappedSiteIndex];
        }
      });
      this.MutateWailistDeniedApplications(mappingsArray);
    }
  }

  @Action({ commit: 'mutateEnrolledApplications' })
  async getEnrolledApplications() {
    const response = await getEnrolledApplications();
    if (response.status == APP_CONST.RESPONSE_200) {
      const data = response.data;
      const incompletePrograms: any = [];
      data && data.forEach((element: any) => {
        if (!element.isCompleted && element.status == APP_CONST.APPLICATION_PUBLISHED_STATUS) {
          if (!incompletePrograms.includes(element.programId)) {
            incompletePrograms.push(element.programId);
          }
        }
      });
      this.allPrograms.forEach((program: any) => {
        if (incompletePrograms.includes(program.programId)) {
          program.isCompleted = false;
        }
      });
    }
    return response;
  }

  @Mutation
  [RESET_SELECTED_CHILD]() {
    const defaultScholarSelection = { id: 0, value: '', siteIds: [] };
    this.selectedChild = defaultScholarSelection;
    this.duplicateApplicationErrorType = null;
  }
}
export default getModule(ApplicationStoreModule);